export default "__VITE_ASSET__u06vWnRL__"